import { GetOrderJobStatusQuery } from "~graphql/sdk";

type CreateOrderError =
  GetOrderJobStatusQuery["getOrderJobStatus"]["createOrderError"];
type ErrorItem = CreateOrderError[0];

export interface CustomErrorResult {
  plainText: string;
  html: string;
}

export function buildCustomErrorMessage(
  customError: CreateOrderError
): CustomErrorResult | null {
  if (!customError?.length) {
    return null;
  }

  const firstError = customError[0];

  switch (firstError.__typename) {
    case "TicketNotAvailableError":
      return buildTicketNotAvailableError(firstError);
    default:
      return null;
  }
}

export function buildCustomErrorTitle(
  customError: CreateOrderError
): string | null {
  if (!customError?.length) {
    return null;
  }

  const firstError = customError[0];

  switch (firstError.__typename) {
    case "TicketNotAvailableError":
      return "Only a few left";
    default:
      return null;
  }
}

function buildTicketNotAvailableError(error: ErrorItem): CustomErrorResult {
  const link = buildWaitlistLink(error.eventId, error.releaseId);
  const waitlistSection = error.shouldDisplayWaitlist
    ? `<br/><p>You can also <a style="text-decoration: underline;" href="${link}">join the waitlist</a> and if more tickets become available, you'll be the first to hear.</p>`
    : "";

  return {
    html: `<p>Please try again with fewer tickets.</p>${waitlistSection}`,
    plainText:
      "There aren't enough tickets for the number you picked. You can try fewer tickets or make sure to sign up to hear if more become available.",
  };
}

function buildWaitlistLink(eventId: string, releaseId?: string): string {
  const baseUrl = `/events/${eventId}/ticket-waitlist`;
  return releaseId ? `${baseUrl}?release=${releaseId}` : baseUrl;
}
